import { render, staticRenderFns } from "./NF.vue?vue&type=template&id=1b9fc9f4&scoped=true&"
import script from "./NF.vue?vue&type=script&lang=js&"
export * from "./NF.vue?vue&type=script&lang=js&"
import style0 from "./NF.vue?vue&type=style&index=0&id=1b9fc9f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9fc9f4",
  null
  
)

export default component.exports